export default {
    "common.error.payment": "An error occurred during payment initialization.",
    "common.error.portal": "Error opening portal: "
};
